import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { message: String }

  submit() {
    const container = this.element.parentElement

    // Hide all sibling forms without removing them
    Array.from(container.children).forEach(child => child.style.display = 'none')

    // Append the spinner
    const feedback = document.createElement('div')
    feedback.className = 'col-span-2 flex items-center justify-center gap-2 text-gray-500 py-6'
    feedback.innerHTML = `
      <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      ${this.messageValue}`
    container.appendChild(feedback)
  }
}
